<button class="close dialog-close-button" mat-button (click)="closeDialog()">X</button>
<div class="container" mat-dialog-content>
    <div>
        <div>
            <form [formGroup]="form" (submit)="submit()">
                <div *ngIf="staticFields.properties.length" class="card-body-static">
                    <div *ngIf="translatable">
                        <div class="card-body-static" formGroupName="staticFields">
                            <div class="form-group form-fields-card form-fields">
                                <div *ngFor="let item of staticFields.properties">
                                    <label *ngIf="!item.toggle" class="field-label">{{ item.name | i18next }}: </label>
                                    <mat-form-field *ngIf="!item.toggle" appearance="fill">
                                        <div class="field">
                                            <input
                                                matInput
                                                formControlName="{{ item.property['de-ch'] }}"
                                                placeholder="{{ item.name | i18next }}"
                                            />
                                        </div>
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div *ngIf="!translatable || hasToggle">
                        <div class="card-body-static" formGroupName="staticFields">
                            <div class="form-group form-fields-card form-fields">
                                <div *ngFor="let item of staticFields.properties">
                                    <div class="field">
                                        <mat-slide-toggle *ngIf="item.toggle" formControlName="{{ item.property }}">{{
                                            item.name | i18next
                                        }}</mat-slide-toggle>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div *ngIf="dynamicFields.properties.length" class="card-body-dynamic" formArrayName="dynamicFields">
                    <div>
                        <div *ngFor="let field of form.get('dynamicFields')['controls']; let i = index">
                            <div>
                                <div [formGroupName]="i">
                                    <div class="form-group form-fields-card form-fields">
                                        <div *ngFor="let item of dynamicFields.properties">
                                            <label class="field-label">{{ item.name | i18next }}: </label>
                                            <mat-form-field appearance="fill">
                                                <div class="field">
                                                    <input
                                                        matInput
                                                        formControlName="{{ item.property['de-ch'] }}"
                                                        placeholder="{{ item.name | i18next }}"
                                                    />
                                                </div>
                                                <mat-error
                                                    *ngIf="
                                                        field.controls[item.property['de-ch']].touched &&
                                                        field.controls[item.property['de-ch']].invalid
                                                    "
                                                >
                                                    <span
                                                        *ngIf="field.controls[item.property['de-ch']].errors.required"
                                                        >{{ getMandatoryText() | i18next }}</span
                                                    >
                                                </mat-error>
                                            </mat-form-field>
                                        </div>
                                    </div>
                                    <button type="button" (click)="remove(i, field)">
                                        <i class="fas fa-minus-circle fa-lg"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div mat-dialog-actions>
                        <button
                            *ngIf="dynamicFields.properties.length"
                            class="btn btn-primary m-1"
                            type="button"
                            (click)="addItem()"
                        >
                            {{ 'aumico_notes_component_options_add_more' | i18next }}
                        </button>
                        <hr />
                        <button class="btn btn-success m-1" [disabled]="!form.valid" type="submit">
                            {{ 'aumico_button_save' | i18next }}
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>
